/* =============================================================================
   Fines Foam — header behavior.

   Owns: the mega menu, the mobile sheet, the scrolled state and the aria
   bookkeeping that goes with them. Depends on window.FF (ff-global.js), which
   theme.liquid loads first.
   ========================================================================== */
(function () {
  'use strict';

  var FF = window.FF || {};

  function init() {
    var section = document.querySelector('.ff-header-section');
    var header = document.getElementById('ff-header');
    if (!header) return;

    var megaToggle = header.querySelector('[data-ff-mega-toggle]');
    var mega = document.getElementById('ff-mega');
    var scrim = header.querySelector('[data-ff-scrim]');
    var burger = header.querySelector('[data-ff-burger]');
    var mobileMenu = document.getElementById('ff-mobile-menu');

    var releaseMegaFocus = null;
    var releaseMobileFocus = null;

    var desktopHover = window.matchMedia('(hover: hover) and (min-width: 990px)');

    /* ------------------------------------------------------------------ */
    /* Scrolled state                                                      */
    /* ------------------------------------------------------------------ */

    if (section && FF.watchScroll) {
      FF.watchScroll(section, 8);
    }

    /* ------------------------------------------------------------------ */
    /* Mega menu                                                           */
    /* ------------------------------------------------------------------ */

    function megaIsOpen() {
      return !!mega && !mega.hidden;
    }

    /*
      `trap` is only set when the panel was opened deliberately (click or
      keyboard). A hover-opened panel does not steal the tab order, because
      the pointer is already doing the navigating.
    */
    function setMega(open, trap) {
      if (!mega) return;
      if (open === megaIsOpen() && !open) return;

      mega.hidden = !open;
      if (scrim) scrim.hidden = !open;
      if (megaToggle) megaToggle.setAttribute('aria-expanded', open ? 'true' : 'false');

      if (releaseMegaFocus) {
        releaseMegaFocus(false);
        releaseMegaFocus = null;
      }

      if (open && trap && FF.trapFocus) {
        releaseMegaFocus = FF.trapFocus(mega, megaToggle);
      }
    }

    if (megaToggle && mega) {
      megaToggle.addEventListener('click', function () {
        setMega(!megaIsOpen(), true);
      });

      megaToggle.addEventListener('mouseenter', function () {
        if (desktopHover.matches) setMega(true, false);
      });

      /* Moving the pointer off the whole header closes the panel. */
      header.addEventListener('mouseleave', function () {
        if (desktopHover.matches && !releaseMegaFocus) setMega(false);
      });

      /* Hovering a sibling nav link means the shopper moved on. */
      header.querySelectorAll('.ff-header__nav a').forEach(function (link) {
        link.addEventListener('mouseenter', function () {
          if (desktopHover.matches && !releaseMegaFocus) setMega(false);
        });
      });

      /* Following a link inside the panel should not leave it open behind. */
      mega.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          setMega(false);
        });
      });
    }

    if (scrim) {
      scrim.addEventListener('click', function () {
        setMega(false);
      });
    }

    /* Click-outside: anything that is not the header closes the panel. */
    document.addEventListener('click', function (event) {
      if (!megaIsOpen()) return;
      if (header.contains(event.target)) return;
      setMega(false);
    });

    /* ------------------------------------------------------------------ */
    /* Mobile sheet                                                        */
    /* ------------------------------------------------------------------ */

    function mobileIsOpen() {
      return !!mobileMenu && mobileMenu.classList.contains('is-open');
    }

    /* The sheet starts just below the header rather than under it. */
    function positionMobileMenu() {
      if (!mobileMenu) return;
      var bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      mobileMenu.style.top = bottom + 'px';
    }

    function setMobile(open) {
      if (!mobileMenu || !burger) return;

      if (open) {
        setMega(false);
        positionMobileMenu();
      }

      mobileMenu.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');

      if (open) {
        mobileMenu.removeAttribute('inert');
        mobileMenu.removeAttribute('aria-hidden');
      } else {
        mobileMenu.setAttribute('inert', '');
        mobileMenu.setAttribute('aria-hidden', 'true');
      }

      if (FF.lockScroll) FF.lockScroll(open);

      if (releaseMobileFocus) {
        releaseMobileFocus(!open);
        releaseMobileFocus = null;
      }
      if (open && FF.trapFocus) {
        releaseMobileFocus = FF.trapFocus(mobileMenu, burger);
      }
    }

    if (burger && mobileMenu) {
      /* Rendered with [hidden] so it cannot flash before CSS lands. */
      mobileMenu.removeAttribute('hidden');
      mobileMenu.setAttribute('inert', '');
      mobileMenu.setAttribute('aria-hidden', 'true');

      burger.addEventListener('click', function () {
        setMobile(!mobileIsOpen());
      });

      mobileMenu.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          setMobile(false);
        });
      });

      window.addEventListener(
        'resize',
        FF.raf
          ? FF.raf(function () {
              if (mobileIsOpen()) positionMobileMenu();
            })
          : positionMobileMenu
      );

      /* Crossing into desktop while the sheet is open would strand the lock. */
      if (typeof desktopHover.addEventListener === 'function') {
        desktopHover.addEventListener('change', function (event) {
          if (event.matches && mobileIsOpen()) setMobile(false);
        });
      }
    }

    /* ------------------------------------------------------------------ */
    /* Escape closes whatever is open                                      */
    /* ------------------------------------------------------------------ */

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (megaIsOpen()) {
        setMega(false);
        if (megaToggle) megaToggle.focus();
      }
      if (mobileIsOpen()) setMobile(false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor re-renders the header section in place. */
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('#ff-header')) init();
  });
})();
